import { registerFormInputComponent } from '@vendure/admin-ui/core'
import { DiscountTiersInputComponent } from './components/discount-tiers-input.component'

export default [registerFormInputComponent('discount-tiers-input', DiscountTiersInputComponent)]
